import React from 'react';
import clsx from 'clsx';
import EnterpriseLayout from "../components/layout/EnterpriseLayout";
import Section from '../components/common/Section';
import TwoFactorSetupForm from '../components/forms/TwoFactorSetupForm';
import TimezoneSettingsForm from '../components/forms/TimezoneSettingsForm';
import styles from '../styles/common/UserSettings.module.scss';

function UserSettings() {

  return (
    <EnterpriseLayout
      pageTitle="Settings"
      pageDescription="Configure your account preferences, security settings, and display options."
      pageBodyClassName={clsx(styles.cUserSettings, "c-user-settings")}
    >
      <section
        className={clsx(styles.cUserSettingsSection, "c-user-settings-section")}
      >
        <div className="c-container">
          <Section>
            <div className="c-section-title">
              <h2 className="h6">
                Display Preferences
              </h2>
            </div>
            <div className={styles.securityContent}>
              <p className={styles.sectionDescription}>
                Configure how dates and times are displayed throughout the application.
              </p>
              <TimezoneSettingsForm />
            </div>
          </Section>

          <Section>
            <div className="c-section-title">
              <h2 className="h6">
                Two-Factor Authentication
              </h2>
            </div>
            <div className={styles.securityContent}>
              <p className={styles.sectionDescription}>
                Add an extra layer of security to your account by requiring a verification code in addition to your password.
              </p>
              <TwoFactorSetupForm />
            </div>
          </Section>
        </div>
      </section>
    </EnterpriseLayout>
  );
}

export default UserSettings;